import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'image-transform' as const;

const imageAspectRatioSchema = z.enum([
  '1:1',
  '2:3',
  '3:2',
  '3:4',
  '4:3',
  '4:5',
  '5:4',
  '9:16',
  '16:9',
  '21:9',
]);

const imageSizeSchema = z.enum(['1K', '2K', '4K']);

const personGenerationSchema = z.enum([
  'ALLOW_ALL',
  'ALLOW_ADULT',
  'ALLOW_NONE',
]);

const imageConfigSchema = z
  .object({
    aspectRatio: imageAspectRatioSchema.optional(),
    imageSize: imageSizeSchema.optional(),
    personGeneration: personGenerationSchema.optional(),
  })
  .optional();

const argumentZod = z.object({
  prompt: z
    .string()
    .describe(
      "User's natural language instruction for image generation or editing"
    ),
  sourceImageUrl: z
    .string()
    .optional()
    .describe(
      'URL of the source image to modify. If omitted, generates a new image'
    ),
  imageConfig: imageConfigSchema.describe(
    'Optional image generation configuration (aspect ratio, size, person generation policy)'
  ),
});

export const imageTransformManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Image transform',
  prettyStatus: {
    executed: 'Transformed image',
    executing: 'Transforming image',
    failed: 'Failed to transform image',
  },
  llmTool: {
    name: toolName,
    description:
      'Generates or edits images using AI. Provide a text prompt for generation, or a source image URL with a prompt for editing.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [{resource: 'SiteFile', action: 'manage'}],
  confirmBeforeExecuting: false,
  timeout: 120_000,
});
